import api, { armorAPI } from '~/services/api';

export function saveLabelSettings(payload) {
  return armorAPI.request({
    url: `/setting/label`,
    method: 'POST',
    data: payload,
  });
}

export function fetchLabelSettings() {
  return armorAPI.request({
    url: `/setting/label`,
    method: 'GET',
  });
}

export function saveDefaultServiceLevel(defaultServiceLevel, defaultReturnServiceLevel) {
  return api.request({
    url: 'v1/ui/account',
    method: 'PATCH',
    data: {
      default_service_level: defaultServiceLevel,
      default_return_service_level: defaultReturnServiceLevel,
    },
  });
}

export function fetchPreviewLink(labelLogoType) {
  return api.request({
    url: `/ui/label/preview?label_logo_type=${labelLogoType}`,
    method: 'GET',
  });
}

export function closeAccount(payload) {
  return armorAPI.request({
    url: `/setting/close-account`,
    method: 'POST',
    data: payload,
  });
}

export default {
  saveLabelSettings,
  fetchLabelSettings,
  saveDefaultServiceLevel,
  fetchPreviewLink,
  closeAccount,
};
